import React from 'react';
import { FaUserSlash } from 'react-icons/fa';

const onLeaveData = [
  { name: 'AMRUT RUPESH PATEL', position: 'FEE COLLECTOR', initials: 'AP' },
  { name: 'SUNITA KRISHNA KADAM', position: 'CLERK', initials: 'SK' },
  { name: 'DIPTI AMIT PATIL', position: 'ACCOUNTANT', initials: 'DP' },
  { name: 'SHRUTI VIJAY BHISE', position: 'ASST TEACHER', initials: 'SB' },
];


//  "on_leave_today": [
//         {
//             "fk_staff__id": 18,
//             "fk_staff__first_name": "Fredric",
//             "fk_staff__last_name": "Frances",
//             "fk_staff__fk_designation__name": "designation",
//             "leave_date": "2025-08-07",
//             "reason": "Something Urgent"
//         }

export function OnLeaveCard({onLeaveData}) {
  return (
    <div className="card shadow-sm h-100 border-0 "style={{backgroundColor:"#ffe7e773"}}>
      <div className="card-header bg-transparent border-0 pb-2 d-flex align-items-center gap-2">
        <FaUserSlash className="text-danger mx-1" />
        <h5 className="mb-0 text-danger fw-semibold">On Leave Today</h5>
      </div>
      <div className="card-body d-flex flex-column gap-3">
        {onLeaveData.length > 0 ? (
          onLeaveData.map((employee, index) => (
            <div
              key={index}
              className="d-flex align-items-center gap-3 bg-white p-3 rounded shadow-sm"
            >
              <div
                className="rounded-circle d-flex justify-content-center align-items-center text-white fw-semibold"
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#dc3545',
                }}
              >
                {employee.fk_staff__first_name ? employee.fk_staff__first_name.charAt(0).toUpperCase() : employee.initials.charAt(0)}
              </div>
              <div className="flex-fill">
                <h6 className="mb-0 fw-medium text-dark">{`${employee.fk_staff__first_name} ${employee.fk_staff__last_name}`}</h6>
                <small className="text-muted">{employee.fk_staff__fk_designation__name}</small>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-4 text-muted small">
            No employees on leave today
          </div>
        )}

        <div className="pt-3 border-top text-center text-muted small">
          Total:{' '}
          <span className="fw-medium text-danger">
            {onLeaveData.length}
          </span>{' '}
          employees on leave
        </div>
      </div>
    </div>
  );
}
